import { combineEpics } from 'redux-observable';
import { addArtistToReleaseEpic } from './add-artist-to-release';
import { createReleaseEpic } from './create-release';
import { updateReleaseEpic } from './update-relase';
import { autosaveEpic } from './autosave';
import { updateDraftURLEpic } from './update-urls';
import { loadReleaseEpic } from './load-release';
import { listReleasesEpic } from './list-releases';
import { listReleasesArtistEpic } from './list-releases-artist';
import { loadReleaseFromURLEpic } from './load-from-url';
import { listArtistReleasesEpic } from './list-artist-releases';
import { updateLastLocationEpic } from './update-last-location';
import { listReleasesSummaryEpic } from './get-list-summary';
import { getReleasesListEpic } from './get-lists';
import { updateActiveListFromUrlEpic } from './update-active-list';
import { publishReleaseEpic } from './publish-release';
import { publicReleaseSuccessEpic } from './publish-release-success';
import { updateTrackCountEpic } from './update-track-count';
import { updateIsExplictEpic } from './update-is-explicit';
import { updateOwnerCountEpic } from './update-owner-count';
import { takedownReleaseEpic } from './takedown-relase';
import { redirectAfterTakedownEpic } from './redirect-after-takedown';
import { redirectAfterTakedownCancelEpic } from './redirect-after-takedown-cancel';
import { listFeaturingEpic } from './list-featuring';
import { confirmTakedownReleaseEpic } from './confirm-takedown';
import { republishAfterTrackUpdateEpic } from './republish-after-track-update';
import { listMultipleArtistsReleasesEpic } from './list-multiple-artists-releases';
import { updateReleaseType } from './update-release-type';
import { validateReleaseDate } from './validate-release-date';
import { validateReleaseArtistsEpic } from './validate-release-artists';
import { validateArtistsAfterLoadEpic } from './validate-artists-after-load';
import { regenerateAfterRepaitEpic } from './regenerate-after-repair';
import { updateStoresAndRegionsEpic } from './update-stores-regions';
import { updatedTakedownReleaseEpic } from './updated-takedown-release';
import { cancelReleaseEpic } from './cancel-release';
import { cancelPendingTakedownEpic } from './cancel-pending-takedown';
import { createCollaboratorsAfterInvite } from './create-collaborators-after-invite';
import { confirmCancelReleaseChangesEpic } from './confirm-cancel-release-changes';
import { listReleasesDeactivatedArtistEpic } from './list-releases-deactivated-artist';
import { hideLockedReleaseSnackbarEpic } from './hide-locked-release-snackbar';
import { successLoadReleaseEpic } from './load-release-success';
import { loadTakedownReleaseEpic } from './load-takedown-release';

const releaseEpic = combineEpics(
  createReleaseEpic,
  updateReleaseEpic,
  autosaveEpic,
  updateDraftURLEpic,
  loadReleaseFromURLEpic,
  loadReleaseEpic,
  getReleasesListEpic,
  listReleasesEpic,
  listReleasesArtistEpic,
  listFeaturingEpic,
  listReleasesSummaryEpic,
  listArtistReleasesEpic,
  listMultipleArtistsReleasesEpic,
  updateTrackCountEpic,
  updateOwnerCountEpic,
  updateStoresAndRegionsEpic,
  updateIsExplictEpic,
  updateLastLocationEpic,
  updateActiveListFromUrlEpic,
  updateReleaseType,
  publishReleaseEpic,
  publicReleaseSuccessEpic,
  confirmTakedownReleaseEpic,
  takedownReleaseEpic,
  updatedTakedownReleaseEpic,
  redirectAfterTakedownEpic,
  redirectAfterTakedownCancelEpic,
  republishAfterTrackUpdateEpic,
  validateReleaseDate,
  validateReleaseArtistsEpic,
  validateArtistsAfterLoadEpic,
  regenerateAfterRepaitEpic,
  cancelReleaseEpic,
  cancelPendingTakedownEpic,
  createCollaboratorsAfterInvite,
  confirmCancelReleaseChangesEpic,
  listReleasesDeactivatedArtistEpic,
  hideLockedReleaseSnackbarEpic,
  successLoadReleaseEpic,
  addArtistToReleaseEpic,
  loadTakedownReleaseEpic
);

export default releaseEpic;
